/*
 * Public API Surface of ngx-scrolltop
 */

export * from './lib/ngx-scrolltop.component';
export * from './lib/ngx-scrolltop.directive';
export * from './lib/ngx-scrolltop.module';
